import { request } from '@/utils/request';

export function getDataResort(data: any) {
  return request({
    url: '/datamap/cdhDataSetConsumer/getStream',
    method: 'get',
    data,
  });
}
